// Program ads (the Donate and newsletter tiles in the program grid) arrive the
// first time they scroll into view, once per page view: the headline resolves
// in stepped frames with a cyan/amber split, then the button lands with the
// label shiver (sass/content/_shows-listing.scss). The Passes page's cards
// arrive the same way: their prices resolve (sass/content/_passes.scss).
// Then they rest, clean. With reduced motion, or without this script,
// they're simply there.

// The arrival's longest animation (the button) ends at 0.6s.
const ARRIVAL_MS = 700;

function initShowAds() {
  const ads = document.querySelectorAll<HTMLElement>(".show-list-item--ad, .pass-card");
  if (!ads.length || !("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const arrive = (ad: HTMLElement) => {
    observer.unobserve(ad);
    if (!ad.classList.contains("is-arrival-pending")) return;
    ad.classList.remove("is-arrival-pending");
    ad.classList.add("is-arriving");
    window.setTimeout(() => ad.classList.remove("is-arriving"), ARRIVAL_MS);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) arrive(entry.target as HTMLElement);
      });
    },
    { threshold: 0.4 }
  );

  ads.forEach((ad) => {
    ad.classList.add("is-arrival-pending");
    observer.observe(ad);
    // Tabbing to the button shows the tile straight away.
    ad.addEventListener("focusin", () => arrive(ad), { once: true });
  });
}

initShowAds();
